import { render, staticRenderFns } from "./bind-phone.vue?vue&type=template&id=124179e8&scoped=true"
import script from "./bind-phone.vue?vue&type=script&lang=js"
export * from "./bind-phone.vue?vue&type=script&lang=js"
import style0 from "./bind-phone.vue?vue&type=style&index=0&id=124179e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124179e8",
  null
  
)

export default component.exports